import React, { useEffect, useState } from "react";
import { AutocompleteInput, required, SelectInput, TextInput, useDataProvider } from "react-admin";
import { AarStorageLocations } from "../../Enums/AarStorageLocations";
import RequirementCategory from "../../Enums/RequirementCategory";

export const EightWingsStorageSelectInputs = ({
  selectedRequirementCategory,
  requirementCategoryList,
  form,
  isUpdate,
  ...props
}) => {
  const [pns, setPnList] = useState([]);
  const [sns, setSnList] = useState([]);
  const [isManuelPn, setIsManuelPn] = useState(false);
  const dataProvider = useDataProvider();
  useEffect(() => {
    var selectedCategory = requirementCategoryList?.find?.(x => x.id == selectedRequirementCategory);
    if (
      [
        RequirementCategory.CageReplenishment,
        RequirementCategory.DafzaPriorityReplenishment,
        RequirementCategory.DafzaReplenishment,
      ].includes(selectedCategory?.category)
    ) {
      setIsManuelPn(true);
    } else {
      setIsManuelPn(false);
    }
  }, [requirementCategoryList, selectedRequirementCategory]);
  useEffect(() => {
    var newValue = form?.getFieldState?.("storage")?.value ?? null;
    if (props.readonly !== true) {
      getPnList(newValue);
      form.change("pn", null);
      form.change("sn", null);
    } else if (newValue != null) {
      getPnList(newValue);
    }
  }, [form?.getFieldState?.("storage")?.value]);

  useEffect(() => {
    var newValue = form?.getFieldState?.("pn")?.value ?? null;
    var storage = form?.getFieldState?.("storage")?.value ?? null;
    if (props.readonly !== true) {
      getSnList(newValue, storage);
      form.change("sn", null);
    } else if (newValue != null) {
      getSnList(newValue, storage);
    }
  }, [form?.getFieldState?.("pn")?.value]);

  const onChangeStorage = event => {
    form.change("storage", event?.target?.value ?? null);
  };

  const getPnList = storage => {
    dataProvider
      .getList("aarstorages/getpnlist", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "ASC" },
        filter: { storage__eq: storage },
      })
      .then(result => {
        if (result?.data?.length > 0) {
          setPnList(result.data as any);
        } else {
          setPnList([]);
        }
      });
  };
  const getSnList = (pn, storage) => {
    dataProvider
      .getList("aarstorages", {
        pagination: { page: 1, perPage: 999 },
        sort: { field: "id", order: "ASC" },
        filter: { pn__eq: pn, storage__eq: storage },
      })
      .then(result => {
        if (result?.data?.length > 0) {
          setSnList(result.data as any);
        } else {
          setSnList([]);
        }
      });
  };
  return (
    <>
      {isManuelPn !== true ? (
        <>
          <SelectInput
            label="Storage"
            source="storage"
            choices={AarStorageLocations}
            optionText="Description"
            optionValue="Value"
            fullWidth
            variant="outlined"
            validate={required()}
            disabled={props?.readonly}
            {...props.storageProps}
            onChange={onChangeStorage}
          />
          <AutocompleteInput
            choices={pns}
            source="pn"
            optionText="pn"
            optionValue="pn"
            variant="outlined"
            resettable
            fullWidth
            validate={required()}
            disabled={props?.readonly || !(form?.getFieldState?.("storage")?.value > 0)}
          />
          <AutocompleteInput
            choices={sns}
            source="sn"
            optionText="sn"
            optionValue="sn"
            variant="outlined"
            resettable
            fullWidth
            validate={required()}
            disabled={props?.readonly || !(form?.getFieldState?.("pn")?.value?.length > 3)}
          />
        </>
      ) : (
        <>
          <TextInput source="pn" label="PN" fullWidth resettable variant="outlined" validate={required()} />
          <TextInput source="sn" label="SN" fullWidth resettable variant="outlined" validate={required()} />
        </>
      )}
    </>
  );
};
export default EightWingsStorageSelectInputs;
